var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dots"},_vm._l((_vm.dotsx),function(dot,d){return _c('SpinnerOct',{key:d,staticClass:"dot",style:({
			'--x': dot.x.toFixed(2) + 'px',
			'--y': dot.y.toFixed(2) + 'px',
			'--z': dot.z.toFixed(2) + 'px',
			'--s': dot.s.toFixed(2) * 0.2,
		})})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }